import { newSidebarName, type SidebarSelection } from "./pageSidebar";
import { getPageType } from "./pageTypeRegistry";

export const LAYOUT_REQUIRED_MESSAGE = "Choose a page layout.";

export const SIDEBAR_CHOICE_REQUIRED_MESSAGE =
  "Choose whether this page starts a new sidebar or uses an existing one.";

export const SIDEBAR_TO_JOIN_REQUIRED_MESSAGE = "Choose which sidebar this page uses.";

export const SIDEBAR_NAME_REQUIRED_MESSAGE = "Enter a sidebar name.";

export const TITLE_MAX_LENGTH = 500;

export const SIDEBAR_NAME_MAX_LENGTH = 500;

const SIDEBAR_NAME_TOO_LONG_MESSAGE = `Keep the sidebar name to ${SIDEBAR_NAME_MAX_LENGTH} characters or fewer.`;

export function validatePageTitle(value: string): true | string {
  const title = value.trim();
  if (!title) {
    return "Enter a title for the page.";
  }
  if (title.length > TITLE_MAX_LENGTH) {
    return `Keep the title to ${TITLE_MAX_LENGTH} characters or fewer.`;
  }
  return true;
}

function validateSidebarName(name: string): true | string {
  if (!name) {
    return SIDEBAR_NAME_REQUIRED_MESSAGE;
  }
  if (name.length > SIDEBAR_NAME_MAX_LENGTH) {
    return SIDEBAR_NAME_TOO_LONG_MESSAGE;
  }
  return true;
}

type LayoutFormValues = {
  type: string;
  title: string;
};

export function validateSidebar(
  selection: SidebarSelection,
  values: LayoutFormValues,
): true | string {
  if (!getPageType(values.type)?.hasSubmenu) {
    return true;
  }
  if (!selection.choice) {
    return SIDEBAR_CHOICE_REQUIRED_MESSAGE;
  }
  if (selection.choice === "join" && !selection.menuId) {
    return SIDEBAR_TO_JOIN_REQUIRED_MESSAGE;
  }
  if (selection.choice === "new") {
    return validateSidebarName(newSidebarName(selection, values.title));
  }
  if (selection.rename !== null) {
    return validateSidebarName(selection.rename.trim());
  }
  return true;
}

export type FocusableFieldName = "type" | "sidebar" | "title" | "slug";

const FIELD_FOCUS_ORDER: FocusableFieldName[] = ["title", "slug", "type", "sidebar"];

export function firstInvalidField(
  invalidFields: Partial<Record<FocusableFieldName, unknown>>,
): FocusableFieldName | undefined {
  return FIELD_FOCUS_ORDER.find(name => invalidFields[name]);
}
